module.exports = __webpack_public_path__ + "static/media/arrow-alt-to-right.17cae9ee.svg";